import { candidateHistoryClient } from "../client/candidateHistoryClient";
import validationErrorForPromise from "../middleware/promiseValidationError";
import { toDataSourceRequest } from "@progress/kendo-data-query";

/**
 * @template T
 * @typedef DataSourceResult
 * @prop {T} data
 * @prop {number} total
 * @prop {object} [errors]
 * @prop {Array<any>} [aggregateResults]
 */
/**
 * @typedef {object} DKN_DMY_ADAY_TARIHCE
 * @prop {number} dkN_DMY_ADAY_TARIHCE_ID
 * @prop {number} dkN_DMY_ADAY_ID
 * @prop {"YENI_BASVURU"|"IKINCI_BASVURU"|"GORUSULDU_OLUMLU"|"GORUSULDU_OLUMSUZ"|"YEDEK_ADAY"} adaY_GORUSME_DURUMU
 * @prop {string} [i_K_ACIKLAMA]
 * @prop {string} crE_DATE
 * @prop {string} crE_USER
 * @prop {string} aD_SOYAD
 */

export default class CandidateHistoryService {
  /**
   *
   * @param {number} id
   * @returns {Promise<DataSourceResult<DKN_DMY_ADAY_TARIHCE>>}
   */
  static list(id) {
    var params = toDataSourceRequest({
      filter: {
        filters: [{ field: "DKN_DMY_ADAY_ID", value: id, operator: "eq" }],
        logic: "and",
      },
    });
    return candidateHistoryClient
      .get("get-list-by-filter", { params })
      .then((d) => d.data)
      .catch(validationErrorForPromise);
  }
  static insert(data) {
    return candidateHistoryClient
      .post("insert", data)
      .then((d) => d.data)
      .catch(validationErrorForPromise);
  }
}
